import type { SVGProps } from "react";
import ChevronDown from "./ChevronDown";
import TrashIcon2 from "./TrashIcon2";

export type IconType = "trash" | "chevron-down";

export type IconBaseProps = SVGProps<SVGSVGElement>;

export interface IconProps extends IconBaseProps {
  name: IconType;
}

export default function Icon({ name, ...otherProps }: IconProps) {
  if (name === "trash") return <TrashIcon2 {...otherProps} />;
  if (name === "chevron-down") return <ChevronDown {...otherProps} />;
  return <TrashIcon2 {...otherProps} />;
}
